import { useForm } from "react-hook-form";
import { useState, useEffect } from "react";
import axios from "../../axios";
import urls from "../../Utils/urls";
import { toast } from "react-toastify";
import { commonToast } from "../../Utils/index.js";
import DossDocAttachmentTable from "../../components/AllTables/DossDocAttachmentTable.jsx";
import { Button } from "../../components/Button.jsx";
import DynamicComponentRenderer from "../../components/DynamicComponentRenderer.jsx";
import PopupWrapper from "../../components/PopupWrapper.jsx";
import FormBox from "../../components/FormBox/FormBox.jsx";
import { useParams } from "react-router-dom";
import { useAbortController } from "../../hooks/useAbortController.js";

const AttachmentsSection = () => {
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm({ mode: "onBlur" });
  const [showPopup, setShowPopup] = useState(false);
  const { signal } = useAbortController();

  let { id, applicationId } = useParams();
  useEffect(() => {
    if (applicationId) {
      setValue("application_id", applicationId);
    }
  }, [applicationId]);

  const onSubmit = async (data) => {
    const finalData = {
      application_id: applicationId,
      filename: data.file.name,
      doc_id: id,
      mime_type: data.file.type,
      comment: data.comment,
    };
    setShowPopup(false);
    const toastId = toast.loading("Submission Pending");
    try {
      const authToken = await axios.get(urls.dashboard.getDossDocToken());
      const res = await axios.post(
        urls.dosssdoc.getDossDocAttachment,
        // `https://api-p.loanlinq.com/ords/loanlinq/v1/dossdoc/dossdoc_attachment`,
        finalData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken.data.token}`,
          },
        },
        { signal }
      );
      setTimeout(() => {
        toast.update(toastId, {
          render: "Submitted Successfully",
          type: "success",
          isLoading: false,
          ...commonToast,
        });
        // setSubmitLoading(false);
      }, 2000);
    } catch (error) {
      if (error.name === "CanceledError") {
        console.error("Fetch request canceled", error.message);
      } else {
        // console.error(error);
        console.error(error);
        toast.error("Submission Failed");
      }
      //   setSubmitLoading(false);
    } finally {
      setTimeout(() => {
        toast.dismiss();
      }, 3000);
    }
  };
  // const onSubmit = async (data) => {
  //   try {
  //     const sanitizedFileName = data.file.name.replace(/ /g, "_");
  //     const formData = new FormData();
  //     formData.append("document", data.file, sanitizedFileName);
  //     formData.append("DOSSDOC", id); // Assuming `id` is defined elsewhere
  //     formData.append("created_by", userDetails); // Assuming `userDetails` is defined elsewhere

  //     // Send formData using axios post request
  //     const response = await axios.post(urls.support.postUploadAttachments, formData, {
  //       headers: {
  //         "Content-Type": "multipart/form-data",
  //       },
  //     });

  //     if (response.status === 200) {
  //       const { filename } = response.data; // Assuming `response.data` contains filename
  //       const finalData = {
  //         application_id: applicationId, // Assuming `applicationId` is defined elsewhere
  //         filename: filename,
  //         doc_id: id, // Assuming `id` is defined elsewhere
  //         mime_type: data.file.type,
  //         comment: data.comment, // Assuming `data.comment` is defined
  //       };

  //       const authTokenResponse = await axios.get(urls.dashboard.getDossDocToken());
  //       const authToken = authTokenResponse.data.token;

  //       // Make a POST request to your endpoint with `finalData` and `authToken`
  //       const res = await axios.post(
  //         `https://api-p.loanlinq.com/ords/loanlinq/v1/dossdoc/dossdoc_attachment`,
  //         finalData,
  //         {
  //           headers: {
  //             "Content-Type": "application/json",
  //             Authorization: `Bearer ${authToken}`,
  //           },
  //         }
  //       );

  //       // Show success toast notification
  //       toast.success("Submitted Successfully");

  //       // Reset form state or perform any additional actions
  //       setShowPopup(false);
  //     }
  //   } catch (error) {
  //     console.error("Submission Error:", error);
  //     toast.error("Submission Failed");
  //   } finally {
  //     // Dismiss the loading toast after a delay
  //     setTimeout(() => {
  //       toast.dismiss();
  //     }, 3000);
  //   }
  // };
  const componentConfig = [
    {
      component: (
        <Button text="Add Attachment" onClick={() => setShowPopup(true)} />
      ),
      role: ["Both"],
      className: "col-sm-12 text-end",
    },
    {
      component: <DossDocAttachmentTable id={id} />,
      role: ["Both"],
      className: "col-sm-12",
    },
    {
      component: (
        <PopupWrapper
          title={<h2 className="p-4 font-weight-bold text-dark">Attachment</h2>}
          Component={
            <>
              <FormBox
                options={attachmentsInputArr}
                register={register}
                watch={watch}
                setValue={setValue}
              />
              <button
                className="btn btn-primary text-white text-end"
                onClick={handleSubmit(onSubmit)}
              >
                Submit
              </button>
            </>
          }
          toShow={showPopup}
          extraClass={"min-width-50vw"}
          closeEventHandler={() => {
            setShowPopup(false);
          }}
        />
      ),
      role: ["Both"],
      className: "col-sm-12",
    },
  ];

  return (
    <div className="p-5">
      <DynamicComponentRenderer componentConfig={componentConfig} />
    </div>
  );
};

export default AttachmentsSection;

const attachmentsInputArr = [
  {
    title: "Application ID",
    field: "application_id",
    type: "text",
    className: "col-12",
    disabled: "True",
  },
  {
    title: "File",
    field: "file",
    type: "file",
    className: "col-12",
  },
  {
    title: "Description",
    field: "comment",
    type: "textarea",
    className: "col-12",
  },
];
